// CodigoIngresoModal.js — Pide el código de 6 dígitos que el servidor envía al correo cuando una
// cuenta del equipo (admin, mentor, coordinador) entra a un proyecto donde los estudiantes entran
// sin contraseña. Lo abre authService.login (services/api.js) con pedirCodigoIngreso(); así
// ninguna pantalla de ingreso tiene que saber de esto.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const EVENTO = 'pedir-codigo-ingreso';

// Devuelve una promesa con el código, '__reenviar__' para pedir otro, o null si se cancela.
export const pedirCodigoIngreso = ({ mensaje, email, error }) => new Promise(resolver => {
  if (!window.__codigoIngresoMontado) {
    // Sin la ventana montada (no debería pasar), al menos se puede escribir el código.
    resolver(window.prompt(`${mensaje || ''}\n\nCódigo de 6 dígitos:`) || null);
    return;
  }
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: { mensaje, email, error, resolver } }));
});

const Fondo = styled.div`
  position: fixed; inset: 0; z-index: 3000; background: rgba(15, 23, 42, 0.55);
  display: flex; align-items: center; justify-content: center; padding: 1rem;
`;
const Caja = styled.form`
  background: #fff; color: #1f2937; border-radius: 14px; width: 100%; max-width: 420px;
  padding: 1.5rem; box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25); font-family: inherit;
  h3 { margin: 0 0 0.6rem; font-size: 1.15rem; }
  p { margin: 0 0 0.9rem; font-size: 0.9rem; line-height: 1.5; color: #475569; }
`;
const Campo = styled.input`
  width: 100%; box-sizing: border-box; padding: 0.75rem; font-size: 1.5rem; letter-spacing: 0.5rem;
  text-align: center; border: 1px solid #cbd5e1; border-radius: 10px; margin-bottom: 0.8rem;
  &:focus { outline: none; border-color: #0f355b; }
`;
const Boton = styled.button`
  width: 100%; padding: 0.75rem; border: none; border-radius: 10px; font-size: 0.95rem; font-weight: 700;
  cursor: pointer; background: #0f355b; color: #fff; &:disabled { opacity: 0.5; cursor: default; }
`;
const Enlace = styled.button`
  background: none; border: none; color: #0f355b; font-size: 0.85rem; cursor: pointer; padding: 0.4rem; text-decoration: underline;
`;
const Error = styled.div`
  background: #fee2e2; color: #991b1b; border-radius: 8px; padding: 0.5rem 0.7rem; font-size: 0.85rem; margin-bottom: 0.8rem;
`;

export default function CodigoIngresoModal() {
  const [pedido, setPedido] = useState(null);
  const [codigo, setCodigo] = useState('');

  useEffect(() => {
    window.__codigoIngresoMontado = true;
    const abrir = (e) => { setCodigo(''); setPedido(e.detail); };
    window.addEventListener(EVENTO, abrir);
    return () => { window.__codigoIngresoMontado = false; window.removeEventListener(EVENTO, abrir); };
  }, []);

  if (!pedido) return null;
  const responder = (valor) => { pedido.resolver(valor); setPedido(null); };

  return (
    <Fondo>
      <Caja onSubmit={e => { e.preventDefault(); if (codigo.length === 6) responder(codigo); }}>
        <h3>Confirma que eres tú</h3>
        <p>{pedido.mensaje}</p>
        {pedido.error && <Error>{pedido.error}</Error>}
        <Campo inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="······" autoFocus
               value={codigo} onChange={e => setCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))} aria-label="Código de 6 dígitos" />
        <Boton type="submit" disabled={codigo.length !== 6}>Entrar</Boton>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
          <Enlace type="button" onClick={() => responder('__reenviar__')}>Enviarme otro código</Enlace>
          <Enlace type="button" onClick={() => responder(null)}>Cancelar</Enlace>
        </div>
      </Caja>
    </Fondo>
  );
}
